module.exports = __webpack_public_path__ + "img/rabbit.eef95cb2.png";